import { EVENT_ALIGNMENTS, type EventAlignment } from '@odo/shared-ui';
import { PresentationSelect, type PresentationSelectOption } from './PresentationSelect';

const ALIGNMENT_LABELS: Record<EventAlignment, string> = {
    left: 'Left',
    center: 'Centered'
};

// Two stacked bars mimicking a title + subtitle line, positioned the way this
// alignment lays the banner out - ties this picker to the same family as the
// theme/icon pickers instead of reading as plain text options.
function AlignmentGlyph({ alignment }: { alignment: EventAlignment }) {
    const itemsClass = alignment === 'center' ? 'items-center' : 'items-start';
    return (
        <span
            aria-hidden="true"
            className={`flex h-5 w-5 flex-shrink-0 flex-col justify-center gap-1 ${itemsClass}`}
        >
            <span className="h-1 w-4 rounded-full bg-gray-400" />
            <span className="h-1 w-2.5 rounded-full bg-gray-400" />
        </span>
    );
}

const ALIGNMENT_OPTIONS: PresentationSelectOption<EventAlignment>[] = EVENT_ALIGNMENTS.map(
    (alignment) => ({
        value: alignment,
        label: ALIGNMENT_LABELS[alignment],
        render: () => <AlignmentGlyph alignment={alignment} />
    })
);

interface EventAlignmentPickerProps {
    id: string;
    value: string;
    onChange: (value: string) => void;
    disabled?: boolean;
}

export function EventAlignmentPicker({ id, value, onChange, disabled }: EventAlignmentPickerProps) {
    return (
        <PresentationSelect
            id={id}
            value={value as EventAlignment}
            options={ALIGNMENT_OPTIONS}
            onChange={onChange}
            disabled={disabled}
        />
    );
}
